import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import CSSTransition from 'react-transition-group/CSSTransition';
import * as notificationStyle from './notification.less';
import { SvgIcon } from '../svg-icon';
import { LocalStorageHelper } from '../../../LoggedInWeb/helpers/localstoragehelper';
import { Text } from '../../components/text';
import { classNames } from '../../../Shared/utils/classnames';

import tickIcon from '../../assets/svg/icon-tick.svg';
import closeIcon from '../../assets/svg/icon-close.svg';
import alertIcon from '../../assets/svg/error.svg';

export class NotificationViewModel {

	@observable
	isActive: boolean;

	private timeoutHandle: number;

	constructor(public content: React.ReactChild, public autoDismissAfterSeconds: number, public hideIcon?: boolean, public storageKeyName?: string, public isError?: boolean) {
		if (storageKeyName) {
			const state = LocalStorageHelper.getLocalStorage().getItem(storageKeyName);
			if (state) {
				this.isActive = false;
				return;
			}
		}

		this.isActive = true;
		this.timeoutHandle = window.setTimeout(this.dismiss, 1000 * autoDismissAfterSeconds);
	}

	@action
	dismiss = () => {
		clearTimeout(this.timeoutHandle);
		this.isActive = false;

		if (this.storageKeyName) {
			LocalStorageHelper.getLocalStorage().setItem(this.storageKeyName, 'true');
		}
	}
}

interface INotificationControllerProps {
	viewModel?: NotificationViewModel;
}

interface INotificationProps {
	content?: React.ReactChild;
	onDismiss?: (() => void);
	hideIcon?: boolean;
	isError?: boolean;
}

@observer
export class NotificationController extends React.Component<INotificationControllerProps> {

	render() {
		const showNotification = this.props.viewModel && this.props.viewModel.isActive;
		const onDismiss = this.props.viewModel && this.props.viewModel.dismiss;
		const classNames = {
			appear: notificationStyle.notificationEnter,
			appearActive: notificationStyle.notificationEnterActive,
			enter: notificationStyle.notificationEnter,
			enterActive: notificationStyle.notificationEnterActive,
			exitActive: notificationStyle.notificationExitActive,
		};

		return (ReactDOM as any).createPortal(
			<CSSTransition in={showNotification} timeout={parseInt(notificationStyle.notificationTransitionDuration)} classNames={classNames} appear unmountOnExit>
				<Notification {...this.props.viewModel} onDismiss={onDismiss} />
			</CSSTransition>,
			document.body,
		);
	}
}

export class Notification extends React.Component<INotificationProps> {

	render() {
		const { hideIcon, onDismiss, content, isError } = this.props;
		const isString = typeof content === 'string';
		return (
			<div className={classNames(notificationStyle.notification, {[notificationStyle.notificationError]: isError})}>
				<div className={`${notificationStyle.notificationContainer}`}>
					<div className={notificationStyle.notificationContent}>
						{!hideIcon ? (
							isError ? (
								<SvgIcon svg={alertIcon} className={classNames(notificationStyle.notificationIcon, notificationStyle.notificationErrorAlert)} />
							) : (
								<SvgIcon svg={tickIcon} className={notificationStyle.notificationIcon} />
							)
						) : null }
						<span className={notificationStyle.notificationText}>
							{isString ? (
								<Text>{content as string}</Text>
							) : (
								content
							)}
						</span>
					</div>
					<button
						className={classNames(notificationStyle.notificationDismiss, {[notificationStyle.notificationErrorDismiss]: isError})}
						type="button"
						aria-label="Close"
						onClick={onDismiss}
					>
						<SvgIcon svg={closeIcon} scale={0.75} />
					</button>
				</div>
			</div>
		);
	}
}
